import type { LikeFolder } from 'shared/src/api/likedFolderService/getLikedFolders/types';
import type { Folder } from '../../../types';
import { FolderCreateItem } from './FolderCreateItem';
import { FolderDisplayItem } from './FolderDisplayItem';

interface FolderItemProps {
  folder: Folder;
  width: number;
  onPressCreate: () => void;
  onPressDelete: (folder: LikeFolder) => void;
  onPressRename: (folder: LikeFolder) => void;
  onPressOpen: (folder: LikeFolder) => void;
}

export const FolderItem = ({
  folder,
  width,
  onPressCreate,
  onPressDelete,
  onPressRename,
  onPressOpen,
}: FolderItemProps) => {
  switch (folder.action) {
    case 'create':
      return <FolderCreateItem width={width} onPress={onPressCreate} />;
    case 'open':
      return (
        <FolderDisplayItem
          folder={folder.folder}
          width={width}
          onPress={() => onPressOpen(folder.folder)}
          onPressRename={onPressRename}
          onPressDelete={onPressDelete}
        />
      );
  }
};
